var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:_setup.buttonClassList,style:(_vm.customStyle),on:{"click":_setup.handleClick}},[(_vm.$slots.icon)?_c('span',{staticClass:"button-icon"},[_vm._t("icon")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }